import { getSocketMandantId } from "./environment";
import { useEffect, useMemo } from "react";

function Socket({ socket, mandantId, onMessage, shop }) {
    const resolvedMandantId = useMemo(() => {
        return getSocketMandantId(mandantId);
    }, [mandantId]);

    useEffect(() => {
        console.log("add socket listener");
        socket.on("connect", onConnect);
        socket.on("disconnect", onDisconnect);
        socket.on("subscribed", onSubrscribed);
        socket.on("events", onSocketEvents);

        if (socket.connected) subscribeChannels();

        return () => {
            console.log("remove socket listener");
            socket.off("connect", onConnect);
            socket.off("disconnect", onDisconnect);
            socket.off("subscribed", onSubrscribed);
            socket.off("events", onSocketEvents);
        };
    }, [socket, resolvedMandantId, shop?.id]);

    useEffect(() => {
        if (socket.connected) subscribeChannels();
    }, [socket, resolvedMandantId, shop?.id]);

    function onConnect() {
        console.log("Socket connected", socket.id);
        subscribeChannels();
    }

    function subscribeChannels() {
        if (!resolvedMandantId || !shop?.id) return;
        socket.emit("subscribe", "m" + resolvedMandantId + ".settings.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".shops.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".menu.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".categories.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".products.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".courses.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".variants.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".variants_categories.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".pos_categories.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".fiscal_printers.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".thermal_printers.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".users.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".roles.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".s" + shop.id + ".rooms.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".s" + shop.id + ".tables.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".s" + shop.id + ".orders.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".s" + shop.id + ".notifications.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".products_stock.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".discounts_products.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".pos_colors.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".glory.#");
        socket.emit("subscribe", "m" + resolvedMandantId + ".cashmatic.#");
    }

    function onDisconnect() {
        console.log("Socket disconnected");
    }

    function onSubrscribed(data) {
        console.log(data);
    }

    function onSocketEvents(message) {
        console.log("new socket event: ", message);
        onMessage(message.table, message.data);
    }

    return null;
}

export default Socket;
